export const getDownstreamHostsValue = (host: string) => {
    if (typeof window !== "undefined") {
        switch (host) {
            case "API_HOST":
                return window.__API_HOST__;
            case "DASH_HOST":
                return window.__DASH_HOST_NAME__;
            case "DASH_CART":
                return window.__DASH_CART_NAME__;
            case "DO_HOST":
                return window.__DO_HOST_NAME__;
            case "GROWTHX_API_HOST":
                return window.__GROWTHX_API_HOST__;
            case "CHECKOUT_WEB_APP_HOST":
                return window.__CHECKOUT_WEB_APP_HOST__;
            case "CHECKOUT_READ_HOST":
                return window.__CHECKOUT_READ_HOST_NAME__;
            case "PAYMENT_PRESENTATION_SERVICE_HOST":
                return window.__PAYMENT_PRESENTATION_SERVICE_HOST__;
            case "USER_SERVICE_HOST":
                return window.__USER_SERVICE_HOST__;
            case "CART_HABIT_FORMING_HOST":
                return window.__CART_HABIT_FORMING_HOST__;
            case "CBCC_API_HOST":
                return window.__CBCC_API_HOST__;
            case "CBCC_REDIRECT_URL":
                return window.__CBCC_REDIRECT_URL__;
            case "PARTNER_REWARDS_HOST":
                return window.__PARTNER_REWARDS_HOST__;
            case "DINEOUT_ORDER_URL":
                return window.__DINEOUT_PAYMENT_ORDER_URL__;
            case "PAYMENT_MODE_ADD_MONEY_RETURN_URL":
                return window.__PAYMENT_MODE_ADD_MONEY_RETURN_URL__;
            case "PAYTM_CALLBACK_URL":
                return window.__PAYTM_CALLBACK_URL__;
            case "RETURN_URL":
                return window.__RETURN_URL__;
            case "TXN_RETURN_URL":
                return window.__TXN_RETURN_URL__;
            case "MOBIKWIK_GATEWAY_URL":
                return window.__MOBIKWIK_GATEWAY_URL__;
            case "MOBIKWIK_MERCHANT_NAME":
                return window.__MOBIKWIK_MERCHANT_NAME__;
            case "MOBIKWIK_MID":
                return window.__MOBIKWIK_MID__;
            case "PAYTM_CHANNEL_ID":
                return window.__PAYTM_CHANNEL_ID__;
            case "PAYTM_INDUSTRY_TYPE_ID":
                return window.__PAYTM_INDUSTRY_TYPE_ID__;
            case "PAYTM_URL":
                return window.__PAYTM_URL__;
            case "PAYTM_WEBSITE":
                return window.__PAYTM_WEBSITE__;
            case "PAYMENT_RETURN_URL":
                return window.__PAYMENT_RETURN_URL__;
            case "MIN_ANDROID_VERSION_FOR_PAYMENT_PENDING_FLOW":
                return window.__MIN_ANDROID_VERSION_FOR_PAYMENT_PENDING_FLOW__;
            case "MIN_IOS_VERSION_FOR_PAYMENT_PENDING_FLOW":
                return window.__MIN_IOS_VERSION_FOR_PAYMENT_PENDING_FLOW__;
            case "MIN_ANDROID_VERSION_FOR_PAYMENT_PENDING_FLOW_PUBLIC_API":
                return window.__MIN_ANDROID_VERSION_FOR_PAYMENT_PENDING_FLOW_PUBLIC_API__;
            case "MIN_IOS_VERSION_FOR_PAYMENT_PENDING_FLOW_PUBLIC_API":
                return window.__MIN_IOS_VERSION_FOR_PAYMENT_PENDING_FLOW_PUBLIC_API__;
            case "REGISTER_PAY_ON_DELIVERY_PUBLIC":
                return window.__REGISTER_PAY_ON_DELIVERY_PUBLIC__;
            case "USE_NEW_PAYMENT_ENDPOINT":
                return window.__USE_NEW_PAYMENT_ENDPOINT__;
            case "PORTAL_HELP_FILE_UPLOAD_URL":
                return window.__PORTAL_HELP_FILE_UPLOAD_URL__;
            case "PORTAL_HELP_FILE_UPLOAD_BUCKET":
                return window.__PORTAL_HELP_FILE_UPLOAD_BUCKET__;
            case "SWIGGY_WEBVIEW_URL_PREFIX":
                return window.__SWIGGY_WEBVIEW_URL_PREFIX__;
            case "IS_STATIC_HTML_BUILD":
                return window.__IS_STATIC_HTML_BUILD__;
            case "IS_REDIRECTION_FLOW":
                return window.__IS_REDIRECTION_FLOW__;
            case "STEAL_STORE_MY_VOUCHERS_URL":
                return window.__STEAL_STORE_MY_VOUCHERS_URL__;
        }
    }
};
